import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function numericalValueIsAbsent(value: number | null | undefined) {
  return value === null || value === undefined || isNaN(value);
}

export function NumericalEditWithConformation({
  value,
  onModified,
}: {
  value: number | null | undefined;
  onModified: (newValue: number) => void;
}) {
  const [currentString, setCurrentString] = useState<string>(!numericalValueIsAbsent(value) ? String(value) : '');
  const [isModified, setIsModified] = useState(false);

  function update() {
    const newStringValue = currentString;
    let newNumericalValue = NaN;
    if (newStringValue.length > 0) newNumericalValue = parseFloat(newStringValue);
    onModified(newNumericalValue);
    setIsModified(false);
  }

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
        background: isModified ? 'rgba(255,200,0,0.25)' : undefined,
      }}
    >
      <input
        type="text"
        style={{
          width: '100%',
          boxSizing: 'border-box',
        }}
        value={isModified ? currentString : !numericalValueIsAbsent(value) ? String(value) : ''}
        onChange={(ev) => {
          const newStringValue = ev.target.value;
          setIsModified(true);
          setCurrentString(newStringValue);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') update();
        }}
      />
      {isModified && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            right: '3px',
            color: 'red',
          }}
          onClick={(ev) => update()}
        >
          <FontAwesomeIcon icon="check" />
        </div>
      )}
    </div>
  );
}
